import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import React from 'react';

import { TellerSettingsView } from 'types/teller';

import { successToastConfig } from '~/packages/common-frontend/constants';

export const InstitutionRemovalModal = ({
  onClose,
  isOpen,
  disconnectAccount,
  tellerItemId,
  disconnectAccountIsLoading,
  name,
}: TellerSettingsView.InstitutionRemovalModalProps) => {
  const toast = useToast();

  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Removal</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to remove your {name} integration?
        </ModalBody>
        <ModalFooter>
          <Flex gap="0.5rem">
            <Button variant="v2-ghost" colorScheme="gray" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              colorScheme="red"
              onClick={async () => {
                await disconnectAccount({ variables: { tellerItemId } });
                toast({
                  ...successToastConfig,
                  title: `${name} integration successfully removed`,
                });
              }}
              isLoading={disconnectAccountIsLoading}
            >
              Remove
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
